import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { HowItWorks } from '../components/HowItWorks';
import { Features } from '../components/Features';
import { ForWho } from '../components/ForWho';
import { Pricing } from '../components/Pricing';
import { Trust } from '../components/Trust';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main id="contenido">
        <Hero />
        <HowItWorks />
        <Features />
        <ForWho />
        <Pricing />
        <Trust />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
